import { NotesState } from './state';

export const notesInitial: NotesState = {
  notesList: [],
};
